import PropTypes from "prop-types";
import {
  AppBar,
  Toolbar,
  IconButton,
  Avatar,
  Menu,
  MenuItem,
  Typography,
  Badge,
  Box,
  Stack,
  Dialog,
  DialogTitle,
  DialogContent,
  useMediaQuery,
  List,
  ListItem,
  ListItemText
} from "@mui/material";
import Grid from "@mui/material/Grid";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { useEffect, useState } from "react";
import { useAuth } from "../context/auth-context";
import { Cookies } from "react-cookie";
import { localStorageItemNames } from "../common/constants";
import { Icon } from "@iconify/react";
import { useNavigate } from "react-router-dom";

import avatar from "../assets/images/avatar.png";
import shortLogo from "../assets/images/logo.svg";
import { routes } from "../routes";
import { useTopics } from "../context/topics-context";

const TopBar = ({ sidebarToggleCollapse, sidebarCollapse }) => {
  const isMobile = useMediaQuery("(max-width: 767px)");
  const { userSignout } = useAuth();
  const cookies = new Cookies();
  const navigate = useNavigate();
  const { notificationData, notificationCount, topicsNotification } = useAuth();
  const { getTopicsById } = useTopics();
  const [anchorElUser, setAnchorElUser] = useState(null);
  const [openNotifications, setOpenNotifications] = useState(false);
  const getUserName = cookies.get(localStorageItemNames.NAME);


  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleLogout = async () => {
    handleCloseUserMenu();
    await userSignout();
  };

  const handleOpenNotifications = () => {
    setOpenNotifications(true);
  };

  const handleCloseNotifications = () => {
    setOpenNotifications(false);
  };

  const handleNotificationClick = async (item) => {
    setOpenNotifications(false);

    const id = item?.topic_id;

    await getTopicsById(id).then((res) => {
      if (res?.success) {
        navigate(routes.VIEWTOPICS)
        localStorage.setItem("topicId", id);
      }
    })

  };


  useEffect(() => {

    topicsNotification({ page: 1, limit: 10000 })
  }, []);

  return (
    <>
      <AppBar
        position="fixed"
        sx={{
          zIndex: 9999,
          boxShadow: "none",
          background: "#ffffff",
          width: isMobile ? "100%" : sidebarCollapse ? "calc(100% - 40px)" : "calc(100% - 276px)",
          ".MuiToolbar-root": {
            minHeight: 72,
            height: 72
          }
        }}
      >
        <Toolbar>
          <Grid container alignItems="center">
            <Grid item xs={8}>
              <Stack direction="row" spacing={2} alignItems="center">
                <IconButton onClick={sidebarToggleCollapse}>
                  <MenuOutlinedIcon sx={{ color: "#000000" }} />
                </IconButton>
                {isMobile && (
                  <img
                    src={shortLogo}
                    alt="Logo"
                    style={{ height: "100%", width: "auto", maxWidth: "40px" }}
                  />
                )}
              </Stack>
            </Grid>

            <Grid item xs={4}>
              <Stack direction="row" spacing={2} alignItems="center" justifyContent="flex-end">
                <IconButton onClick={handleOpenNotifications}>
                  <Badge badgeContent={notificationCount || 3} color="error">
                    <NotificationsIcon />
                  </Badge>
                </IconButton>


                <Typography variant="subtitle2" color="text.primary" sx={{ fontWeight: 500 }}>
                  Hi, {getUserName || "User"}
                </Typography>

                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    cursor: "pointer"
                  }}
                  onClick={handleOpenUserMenu}
                >

                  <Avatar alt="Profile" src={avatar} sx={{ width: 36, height: 36 }} />
                </Box>

                <Menu
                  anchorEl={anchorElUser}
                  open={Boolean(anchorElUser)}
                  onClose={handleCloseUserMenu}
                  sx={{ mt: "19px" }}
                  MenuListProps={{
                    disablePadding: true
                  }}
                >
                  <MenuItem
                    onClick={handleLogout}
                    sx={{
                      py: 1,
                      px: 2,
                    }}
                  >
                    <Icon icon="heroicons-outline:logout" />
                    <Typography>Logout</Typography>
                  </MenuItem>
                </Menu>
              </Stack>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>

      <Dialog
        open={openNotifications}
        onClose={handleCloseNotifications}
        fullWidth
        maxWidth="xs"
        PaperProps={{
          sx: {
            position: "fixed",
            top: 80,
            right: 16,
            m: 0,
            width: 320,
            borderRadius: 2
          }
        }}
      >
        <DialogTitle>Notifications</DialogTitle>
        <DialogContent dividers>
          <List sx={{ cursor: "pointer" }}>
            {notificationData?.length > 0 ? notificationData?.map((note, index) => (
              <ListItem button key={index} onClick={() => handleNotificationClick(note)}>
                <ListItemText primary={note?.description} />
              </ListItem>
            )) : (
              <ListItem>
                <ListItemText primary="No new notifications" />
              </ListItem>
            )
            }
          </List>
        </DialogContent>
      </Dialog>
    </>
  );
};

TopBar.propTypes = {
  sidebarToggleCollapse: PropTypes.func,
  sidebarCollapse: PropTypes.bool
};

export default TopBar;
